export default __webpack_public_path__ + "static/media/x.039cba6c.svg";